import BlockText from "../block-content/block-text";
import asphalt from "../../images/patterns/asfalt-dark.png";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";
import { SchemaVideoObject } from "../schema-video-object";

const VideoFeatureBlock = ({ pageBlock, section }) => {
  const VideoStyles = styled.section`
    background: #0071ba url("${asphalt}");
  `;
  const TextStyles = styled.div`
    a {
      ${tw`block md:inline-block text-sm shadow-lg uppercase text-center md:text-base px-4 md:px-6 py-3 rounded font-bold bg-yellow-500 text-yellow-900 transition hover:ring`}
    }
    p {
      ${tw`text-sm md:text-lg mb-6`}
    }
  `;

  return (
    <VideoStyles>
      <section className="py-10 md:py-24 text-white">
        <div className="max-w-7xl px-4 mx-auto">
          <div className="flex flex-wrap">
            <div className="w-full md:w-4/12 mb-6 md:pr-16 mr-auto">
              <h2 className="text-yellow-500 leading-tight font-bold tracking-tighter text-2xl md:text-3xl mb-1 md:mb-3">
                {pageBlock.title}
              </h2>
              {pageBlock.subtitle && (
                <h3 className="text-xl font-bold tracking-tight text-yellow-300 mb-4 md:mb-2">
                  {pageBlock.subtitle}
                </h3>
              )}
              <TextStyles>
                <BlockText blocks={pageBlock._rawBody} />
                {pageBlock.buttonText ? (
                  <>
                    {" "}
                    {pageBlock.link && pageBlock.link.href ? (
                      <a href={pageBlock.link.href}>
                        {pageBlock.buttonText}
                      </a>
                    ) : pageBlock.link &&
                      pageBlock.link.reference &&
                      pageBlock.link.reference.path ? (
                     <a href={pageBlock.link.reference.path}>
                        {pageBlock.buttonText}
                      </a>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </TextStyles>
            </div>
            <div className="w-full md:w-8/12 md:pr-4">
              {pageBlock.image && pageBlock.image.asset && (
                <Image
                  {...pageBlock.image}
                  width={736}
                  className="align-top"
                  alt={""}
                />
              )}
              <div className="embed-responsive aspect-ratio-16/9 shadow-2xl">
                <iframe
                  title={`YouTube Video`}
                  src={`https://www.youtube.com/embed/${pageBlock.videoID}?rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {pageBlock?.videoID && (
        <SchemaVideoObject
          name={pageBlock.title}
          description={pageBlock?.subtitle || ""}
          thumbnail={
            pageBlock?.image?.asset?.url ||
            `https://img.youtube.com/vi/${pageBlock?.videoID.trim()}/maxresdefault.jpg`
          }
          embedUrl={`https://www.youtube.com/embed/${pageBlock?.videoID.trim()}?rel=0`}
        />
      )}
    </VideoStyles>
  );
};

export default VideoFeatureBlock;
